import React from 'react';
import { Navigate } from 'react-router-dom';

import { App } from 'components';
// If we don't import _something_ from 'components', it all blows up. No idea why.

const routes = [
  {
    path: '/read',
    element: <App />,
  },
  {
    path: '/read/:bookPk',
    element: <App />,
  },
  {
    path: '/read/:bookPk/:documentNumber',
    element: <App />,
  },
  {
    path: '/read/document/*',
    element: <div>Service worker error</div>,
  },
  {
    path: '*',
    element: <Navigate to="/read" />,
  },
];

export default routes;
